import PropTypes from 'prop-types';
import React from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Step, StepLabel, Stepper } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { useMaterialProgressBar, withWidget } from '@ezbobdev/ui-commons';
import { MaterialTypography } from '@ezbobdev/ui-widgets-ezbob';

const Wrapper = styled.div`
  ${(props) => {
    const { theme, backgroundImage, backgroundPosition } = props;

    return css`
      display: flex;
      justify-content: center;

      .ScreenWrapper__progress-bar-summary {
        ${visuallyHidden}
      }

      ${theme.breakpoints.up('md')} {
        background-image: url(${backgroundImage}); /* @noflip */
        background-position: ${backgroundPosition};
        background-size: auto 100%;
        background-repeat: no-repeat;
        border-radius: 0.8rem 0.8rem 0 0;
      }
    `;
  }}
`;

const MaterialProgressBar = (props) => {
  const {
    activeStepNumber,
    progressBarSteps,
    backgroundImage,
    backgroundPosition,
    getStepDescription,
    stepperAriaLabel,
  } = useMaterialProgressBar(props, MaterialProgressBar.displayName);

  return (
    <Wrapper
      data-testid={MaterialProgressBar.displayName}
      backgroundImage={backgroundImage}
      backgroundPosition={backgroundPosition}
      aria-live="off"
    >
      <div className="ScreenWrapper__progress-bar-summary">{stepperAriaLabel}</div>
      <Stepper role="list" alternativeLabel activeStep={activeStepNumber}>
        {progressBarSteps?.map((step, index) => {
          const { progressBarStep, label } = step;

          return (
            <Step role="listitem" key={progressBarStep}>
              <MaterialTypography srOnly>{getStepDescription(step, index)}</MaterialTypography>
              <StepLabel aria-hidden={true}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Wrapper>
  );
};

MaterialProgressBar.displayName = 'MaterialProgressBar';

MaterialProgressBar.propTypes = {
  name: PropTypes.string,
};

export default React.memo(withWidget(MaterialProgressBar));
